import { Container, Grid, Link, Typography } from "@mui/material";
import React from "react";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {
  BtnDiv,
  ContainerWraper,
  ContentGrid,
  Div,
  EmptyGrid,
  FooterDiv,
  GRID,
  GradiantDiv,
  Image,
  ImageGrid,
  InnerDiv,
  Paragraph,
  ParentGrid,
  RoadMapImage,
  SectionWraper,
  SocialDiv,
  TokenDiv,
} from "./style";
import LockerMenu from "../../Components/Menu";
import CustomButton from "../../Components/CustomBtn";
const Tokenomics = () => {
  return (
    <SectionWraper maxWidth="xxl">
      <GradiantDiv />
      <ContainerWraper>
        <LockerMenu />
        <ParentGrid container>
          <EmptyGrid
            item
            xs={12}
            sx={{ height: "80px", width: "100%" }}
          ></EmptyGrid>
          <ContentGrid item xs={12} sm={6}>
            <Image src="./Image/tokenomicsHeading.png" alt="" />
            <Paragraph>
              Everything you need to know, including token distribution, max
              wallet, and buy and sell taxes. These taxes will be used for token
              development, service hire, and marketing but will be slowly
              lowered to 0% tax to facilitate CEX listings.
            </Paragraph>
            <TokenDiv>
              <InnerDiv>
              <Typography
                color="#fff"
                sx={{
                  fontFamily: "PoppinsSB",
                  fontSize: "38px",
                  textAlign: "center",
                }}
              >
                100M
              </Typography>
              <Paragraph mt="0px" ta="center">
              Total Supply  
              </Paragraph>
              </InnerDiv>
              <InnerDiv>
              <Typography
                color="#fff"
                sx={{
                  fontFamily: "PoppinsSB",
                  fontSize: "38px",
                  textAlign: "center",
                }}
              >
                3%
              </Typography>
              <Paragraph mt="0px" ta="center">
              Buy Tax
              </Paragraph>
              </InnerDiv>
              <InnerDiv>
              <Typography
                color="#fff"
                sx={{
                  fontFamily: "PoppinsSB",
                  fontSize: "38px",
                  textAlign: "center",
                }}
              >
                3%
              </Typography>
              <Paragraph mt="0px" ta="center">
              Sell Tax  
              </Paragraph>
              </InnerDiv>
            </TokenDiv>
            <hr style={{background:"#fff", height:"1px", width:"100%", margin:"30px 0"}} />
          <GRID item xs={12}>
            <Div>
            <Paragraph fm="PoppinsSB" mt="0px" ta="center">
            NAME  
              </Paragraph>
              <Paragraph fm="PoppinsSB" mt="0px" ta="center">
              BABY SHIBA  
              </Paragraph>
            </Div>
            <Div>
            <Paragraph fm="PoppinsSB" mt="0px" ta="center">
            SYMBOL  
              </Paragraph>
              <Paragraph fm="PoppinsSB" mt="0px" ta="center">
              $BSHIBA  
              </Paragraph>
            </Div>
          </GRID>
          <Div bgc="#F88523" b="none" style={{width:"97%"}}>
          <Paragraph fm="PoppinsSB" mt="0px" ta="center">
            CONTRACT  
              </Paragraph>
              <Paragraph sx={{display:"flex"}} fm="PoppinsSB" mt="0px" ta="center">
              TBA
                <FileCopyIcon sx={{color:"#fff" , fontSize:"20px"}}/>
              </Paragraph>
          </Div>
          </ContentGrid>
        </ParentGrid>
        <Grid container>
          <Grid item xs={12}>
            <FooterDiv>
              <Paragraph>
                Copyright ©2023 shibarium. baby All rights reserved.
              </Paragraph>
              <SocialDiv>
                Follow us on:
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/twiter.png"
                    alt="Twiter"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/telegram.png"
                    alt="telegram"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/mediam.png"
                    alt="mediam"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
              </SocialDiv>
            </FooterDiv>
          </Grid>
        </Grid>
      </ContainerWraper>
    </SectionWraper>
  );
};

export default Tokenomics;
